import { useEffect, useRef } from "react";
import { useNetworkState } from "react-use";

export const useRequestReSync = (callback: () => void) => {
  const { online, previous: previousOnline } = useNetworkState();
  const callbackCalledRef = useRef(false);
  useEffect(() => {
    if (callbackCalledRef.current) {
      return;
    }
    if (!online && callbackCalledRef.current) {
      callbackCalledRef.current = false;
      return;
    }
    if (previousOnline !== undefined && !previousOnline && online) {
      callbackCalledRef.current = true;
      callback();
    }
  }, [callback, online, previousOnline]);
};
